// extracted by mini-css-extract-plugin
export default {"container":"CardDetail_container__JFFwm","release_note":"CardDetail_release_note__q3ODy"};